"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Evexia API
 * OpenAPI Spec for Evexia APIs
 *
 * The version of the OpenAPI document: 1.0
 * Contact: ch_engineering@calm.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvitationsApi = exports.InvitationsApiFactory = exports.InvitationsApiFp = exports.InvitationsApiAxiosParamCreator = void 0;
const tslib_1 = require("tslib");
const axios_1 = tslib_1.__importDefault(require("axios"));
// @ts-ignore
const base_1 = require("../base");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
/**
 * InvitationsApi - axios parameter creator
 * @export
 */
const InvitationsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | invitation | c |
         * @summary Generate an invitation
         * @param {number} recipientId A ID of the recipient self circle
         * @param {CircleInvitationType} invitationType Type of invitation to create
         * @param {string} auth0IDToken Auth0 id token that contains email claim
         * @param {CircleInviteRequest} circleInviteRequest Invite request
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvitationV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId, invitationType, auth0IDToken, circleInviteRequest, circleAuthorizationToken, }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('createInvitationV1', 'recipientId', recipientId);
            // verify required parameter 'invitationType' is not null or undefined
            (0, common_1.assertParamExists)('createInvitationV1', 'invitationType', invitationType);
            // verify required parameter 'auth0IDToken' is not null or undefined
            (0, common_1.assertParamExists)('createInvitationV1', 'auth0IDToken', auth0IDToken);
            // verify required parameter 'circleInviteRequest' is not null or undefined
            (0, common_1.assertParamExists)('createInvitationV1', 'circleInviteRequest', circleInviteRequest);
            const localVarPath = `/v1/circles/{recipient_id}/invitations/{invitation_type}`
                .replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)))
                .replace(`{${'invitation_type'}}`, encodeURIComponent(String(invitationType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (auth0IDToken !== undefined && auth0IDToken !== null) {
                localVarHeaderParameter['Auth0-ID-Token'] =
                    String(auth0IDToken);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/circles/{recipient_id}/invitations/{invitation_type}`,
                sdkMethod: 'createInvitationV1',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(circleInviteRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | invitation | d |
         * @summary Deletes an invitation by id.
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} invitationId Invitation ID
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInvitationV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId, invitationId, circleAuthorizationToken, }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('deleteInvitationV1', 'recipientId', recipientId);
            // verify required parameter 'invitationId' is not null or undefined
            (0, common_1.assertParamExists)('deleteInvitationV1', 'invitationId', invitationId);
            const localVarPath = `/v1/circles/{recipient_id}/invitations/{invitation_id}`
                .replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)))
                .replace(`{${'invitation_id'}}`, encodeURIComponent(String(invitationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/circles/{recipient_id}/invitations/{invitation_id}`,
                sdkMethod: 'deleteInvitationV1',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | invitation | u |
         * @summary Extends the expiration time for an invitation.
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} invitationId Invitation ID
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        extendInvitationV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId, invitationId, circleAuthorizationToken, }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('extendInvitationV1', 'recipientId', recipientId);
            // verify required parameter 'invitationId' is not null or undefined
            (0, common_1.assertParamExists)('extendInvitationV1', 'invitationId', invitationId);
            const localVarPath = `/v1/circles/{recipient_id}/invitations/{invitation_id}/extend`
                .replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)))
                .replace(`{${'invitation_id'}}`, encodeURIComponent(String(invitationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/circles/{recipient_id}/invitations/{invitation_id}/extend`,
                sdkMethod: 'extendInvitationV1',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Returns an invitation by short code
         * @param {string} inviteCode A short invite code that can be used to retrieve the invitation with invite_id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvitationByCodeV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ inviteCode }, options = {}) {
            // verify required parameter 'inviteCode' is not null or undefined
            (0, common_1.assertParamExists)('getInvitationByCodeV1', 'inviteCode', inviteCode);
            const localVarPath = `/v1/invitations/codes/{invite_code}`.replace(`{${'invite_code'}}`, encodeURIComponent(String(inviteCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/invitations/codes/{invite_code}`,
                sdkMethod: 'getInvitationByCodeV1',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Returns an invitation by id
         * @param {string} invitationId Invitation ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvitationByIdV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ invitationId }, options = {}) {
            // verify required parameter 'invitationId' is not null or undefined
            (0, common_1.assertParamExists)('getInvitationByIdV1', 'invitationId', invitationId);
            const localVarPath = `/v1/invitations/{invitation_id}`.replace(`{${'invitation_id'}}`, encodeURIComponent(String(invitationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/invitations/{invitation_id}`,
                sdkMethod: 'getInvitationByIdV1',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | invitation | r |
         * @summary Get all invitations for a recipient
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} auth0IDToken Auth0 id token that contains email claim
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {'dependent'} [type] Type of invitation to look up
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvitationsV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId, auth0IDToken, circleAuthorizationToken, type, }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('getInvitationsV1', 'recipientId', recipientId);
            // verify required parameter 'auth0IDToken' is not null or undefined
            (0, common_1.assertParamExists)('getInvitationsV1', 'auth0IDToken', auth0IDToken);
            const localVarPath = `/v1/circles/{recipient_id}/invitations`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (auth0IDToken !== undefined && auth0IDToken !== null) {
                localVarHeaderParameter['Auth0-ID-Token'] =
                    String(auth0IDToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/circles/{recipient_id}/invitations`,
                sdkMethod: 'getInvitationsV1',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.InvitationsApiAxiosParamCreator = InvitationsApiAxiosParamCreator;
/**
 * InvitationsApi - functional programming interface
 * @export
 */
const InvitationsApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.InvitationsApiAxiosParamCreator)(configuration);
    return {
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | invitation | c |
         * @summary Generate an invitation
         * @param {number} recipientId A ID of the recipient self circle
         * @param {CircleInvitationType} invitationType Type of invitation to create
         * @param {string} auth0IDToken Auth0 id token that contains email claim
         * @param {CircleInviteRequest} circleInviteRequest Invite request
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvitationV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createInvitationV1(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | invitation | d |
         * @summary Deletes an invitation by id.
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} invitationId Invitation ID
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInvitationV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteInvitationV1(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | invitation | u |
         * @summary Extends the expiration time for an invitation.
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} invitationId Invitation ID
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        extendInvitationV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.extendInvitationV1(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Returns an invitation by short code
         * @param {string} inviteCode A short invite code that can be used to retrieve the invitation with invite_id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvitationByCodeV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getInvitationByCodeV1(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Returns an invitation by id
         * @param {string} invitationId Invitation ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvitationByIdV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getInvitationByIdV1(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | invitation | r |
         * @summary Get all invitations for a recipient
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} auth0IDToken Auth0 id token that contains email claim
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {'dependent'} [type] Type of invitation to look up
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvitationsV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getInvitationsV1(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.InvitationsApiFp = InvitationsApiFp;
/**
 * InvitationsApi - factory interface
 * @export
 */
const InvitationsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.InvitationsApiFp)(configuration);
    return {
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | invitation | c |
         * @summary Generate an invitation
         * @param {number} recipientId A ID of the recipient self circle
         * @param {CircleInvitationType} invitationType Type of invitation to create
         * @param {string} auth0IDToken Auth0 id token that contains email claim
         * @param {CircleInviteRequest} circleInviteRequest Invite request
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvitationV1(params, options) {
            return localVarFp
                .createInvitationV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | invitation | d |
         * @summary Deletes an invitation by id.
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} invitationId Invitation ID
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInvitationV1(params, options) {
            return localVarFp
                .deleteInvitationV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | invitation | u |
         * @summary Extends the expiration time for an invitation.
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} invitationId Invitation ID
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        extendInvitationV1(params, options) {
            return localVarFp
                .extendInvitationV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Returns an invitation by short code
         * @param {string} inviteCode A short invite code that can be used to retrieve the invitation with invite_id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvitationByCodeV1(params, options) {
            return localVarFp
                .getInvitationByCodeV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Returns an invitation by id
         * @param {string} invitationId Invitation ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvitationByIdV1(params, options) {
            return localVarFp
                .getInvitationByIdV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | invitation | r |
         * @summary Get all invitations for a recipient
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} auth0IDToken Auth0 id token that contains email claim
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {'dependent'} [type] Type of invitation to look up
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvitationsV1(params, options) {
            return localVarFp
                .getInvitationsV1(params, options)
                .then((request) => request(axios, basePath));
        },
    };
};
exports.InvitationsApiFactory = InvitationsApiFactory;
/**
 * InvitationsApi - object-oriented interface
 * @export
 * @class InvitationsApi
 * @extends {BaseAPI}
 */
class InvitationsApi extends base_1.BaseAPI {
    /**
     * URL `/v1/circles/{recipient_id}/invitations/{invitation_type}`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | invitation | c |
     * @summary Generate an invitation
     * @param {number} recipientId A ID of the recipient self circle
     * @param {CircleInvitationType} invitationType Type of invitation to create
     * @param {string} auth0IDToken Auth0 id token that contains email claim
     * @param {CircleInviteRequest} circleInviteRequest Invite request
     * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvitationsApi
     */
    createInvitationV1(params, options) {
        return (0, exports.InvitationsApiFp)(this.configuration)
            .createInvitationV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/circles/{recipient_id}/invitations/{invitation_id}`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | invitation | d |
     * @summary Deletes an invitation by id.
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} invitationId Invitation ID
     * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvitationsApi
     */
    deleteInvitationV1(params, options) {
        return (0, exports.InvitationsApiFp)(this.configuration)
            .deleteInvitationV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/circles/{recipient_id}/invitations/{invitation_id}/extend`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | invitation | u |
     * @summary Extends the expiration time for an invitation.
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} invitationId Invitation ID
     * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvitationsApi
     */
    extendInvitationV1(params, options) {
        return (0, exports.InvitationsApiFp)(this.configuration)
            .extendInvitationV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/invitations/codes/{invite_code}`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Returns an invitation by short code
     * @param {string} inviteCode A short invite code that can be used to retrieve the invitation with invite_id.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvitationsApi
     */
    getInvitationByCodeV1(params, options) {
        return (0, exports.InvitationsApiFp)(this.configuration)
            .getInvitationByCodeV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/invitations/{invitation_id}`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Returns an invitation by id
     * @param {string} invitationId Invitation ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvitationsApi
     */
    getInvitationByIdV1(params, options) {
        return (0, exports.InvitationsApiFp)(this.configuration)
            .getInvitationByIdV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/circles/{recipient_id}/invitations`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | invitation | r |
     * @summary Get all invitations for a recipient
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} auth0IDToken Auth0 id token that contains email claim
     * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
     * @param {'dependent'} [type] Type of invitation to look up
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvitationsApi
     */
    getInvitationsV1(params, options) {
        return (0, exports.InvitationsApiFp)(this.configuration)
            .getInvitationsV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
exports.InvitationsApi = InvitationsApi;
//# sourceMappingURL=invitations-api.js.map